import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M23.898 10.558c-.598-2.737-3.09-4.692-5.88-4.692h-.5C16.025 1.564 11.338-.88 6.854.293 4.46.881 2.567 2.346 1.272 4.301.075 6.354-.323 8.701.275 10.95c.598 2.346 2.193 4.301 4.386 5.475.498.293 1.096.195 1.395-.294s.1-1.075-.4-1.368c-1.693-.88-2.89-2.444-3.388-4.302-.498-1.76-.2-3.52.798-5.18.897-1.565 2.492-2.738 4.286-3.13 3.688-.977 7.575 1.272 8.472 4.89.1.39.499.781.997.781h1.196c1.894 0 3.489 1.27 3.887 3.128.4 2.15-.996 4.204-3.09 4.595a1.015 1.015 0 0 0-.797 1.173c.1.49.498.782.997.782h.2c3.189-.684 5.282-3.813 4.684-6.94m-8.871 5.083H10.94l2.99-4.3c.3-.49.2-1.076-.3-1.37-.497-.293-1.095-.195-1.394.294L8.249 16.13c-.2.294-.2.684 0 .978.1.293.399.49.797.49h4.087l-2.99 4.3c-.3.49-.2 1.075.299 1.37.199.096.398.194.598.194.299 0 .598-.195.797-.39l3.987-5.866c.2-.294.2-.685 0-.978s-.4-.587-.797-.587"
    }, null, -1)
  ]))]))
}
export default { render: render }